// wrapper for all functionalities
function ABDOMap() {
    this.version = "1.3";
    this.revision = "4714e658163978cb594ffc451ce154ef4ea7415d";

    this._init();
}

(function($){
    $.prototype = {
        _init: function() {
            this._enable_debug_alert();
        },

        _onerror: function(msg, url, linenumber) {
            alert('Error message: ' + msg + '\nURL: ' + url + '\nLine Number: ' + linenumber);
            return false;
        },

        _enable_debug_alert: function() {
            if (this._is_dev()) {
                window.onerror = this._onerror.bind(this);
            }
        },

        _get_pagename: function() {
            return document.URL.split('/').pop();
        },

        _is_dev: function() {
            return this._get_pagename()[0] == '_';
        },
    };

    $.instance = new $();

    /**
     * Creates basic inheritance of functions
     * @param {Function} child_func 
     * @param {Function} parent_func 
     */
     $._inherit = function(child_func, parent_func) {
        child_func.prototype = Object.create(parent_func.prototype);
        child_func.prototype.constructor = parent_func;
        Object.defineProperty(child_func.prototype, 'constructor', {
            value: parent_func,
            enumerable: false,
            writable: true
        });
    };

    $._create_component = function(component_func, members) {
        $._inherit(component_func, $.Component);
        Object.assign(component_func.prototype, members);
    };

    $._get_default_zoom = function() {
        var viewport = ABDOUtil.getViewer().viewport;
        var max_zoom = viewport.getMaxZoom();
        var min_zoom = viewport.getMinZoom();
        
        return (max_zoom - min_zoom) / 10.0;
    };

    // イベントの機能を付与 
    Emitter($);

})(ABDOMap);